import React from "react";
import { List, Users } from "react-feather";
import UserProfile from "../Pages/Admin/UserProfile/UserProfile";
import Schools from "../Pages/SuperAdmin/Schools/Schools";
import UserRequests from "../Pages/SuperAdmin/UserRequests/UserRequests";
import UserRequestDetails from "../Pages/SuperAdmin/UserRequestDetails/UserRequestDetails";

export const SuperAdminRoutes = [
  {
    id: "super_admin_users",
    path: "/user/super-admin/users",
    title: "Users",
    layout: "super_admin",
    parent: true,
    component: <Schools />,
    icon: <List />,
    activeIcon: (
      <i className="fa-solid fa-gauge" style={{ color: "#ffffff" }}></i>
    ),
  },
  {
    id: "user_profile",
    path: "/user/admin/users/profile/:id",
    title: "User Profile",
    layout: "admin",
    parent: false,
    component: <UserProfile />,
    icon: <Users size={18} />,
  },

  {
    id: "super_admin_requests",
    path: "/user/super-admin/requests",
    title: "Requests",
    layout: "super_admin",
    parent: true,
    component: <UserRequests />,
    icon: <i className="fa-solid fa-address-book"></i>,
    activeIcon: (
      <i className="fa-solid fa-address-book" style={{ color: "#ffffff" }}></i>
    ),
  },

  {
    id: "super_admin_requests_details",
    path: "/user/super-admin/requests/:id",
    title: "Requests Details",
    layout: "super_admin",
    parent: false,
    component: <UserRequestDetails />,
    icon: <i className="fa-solid fa-address-book"></i>,
    activeIcon: (
      <i className="fa-solid fa-address-book" style={{ color: "#ffffff" }}></i>
    ),
  },
];
